interface BadgeProps {
  label: string;
  variant?: string;
}

const variants: Record<string, string> = {
  default: 'pill',
  success: 'pill pill-success',
  warning: 'pill pill-warning',
  danger: 'pill pill-danger',
  info: 'pill pill-info',
};

export function Badge({ label, variant = 'default' }: BadgeProps) {
  return <span className={variants[variant] ?? variants.default}>{label}</span>;
}
